import { ColumnDef } from '@tanstack/react-table';

import { IPaginationTable } from '../common/interfaces/IPaginationTable';

import Table from '@/components/table/common/Table';
import { ICollection } from '@/interfaces/api/collection/ICollection';
import { IShopifySubscriptionDiscount } from '@/interfaces/api/shopify-subscription-discount/IShopifySubscriptionDiscount';
import { IShopifySubscriptionDiscountWithAction } from '@/interfaces/api/shopify-subscription-discount/IShopifySubscriptionDiscountWithAction';

const ShopifySubscriptionDiscountTable = ({
	collectionShopifySubscriptionDiscount,
	paginationOption,
	columns,
}: {
	collectionShopifySubscriptionDiscount: IShopifySubscriptionDiscount[];
	paginationOption: IPaginationTable;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	columns: ColumnDef<IShopifySubscriptionDiscountWithAction, any>[];
}) => {
	const handleCollectionWithAction = (
		collection: IShopifySubscriptionDiscount[],
	): ICollection<IShopifySubscriptionDiscountWithAction> => {
		return {
			data: collection.map((item) => ({
				...item,
				action: '',
			})),
			pageCount: 1,
			itemCount: collection.length,
			pageNumber: 1,
			pageSize: collection.length,
		};
	};

	return (
		<div
			className="flex flex-col items-center border-t border-gray-300 w-full bg-grey-0 border border-gray-300 rounded-md px-[2rem]"
			data-test="shopify-subscription-discounts-dashboard"
		>
			<div className="w-full my-4">
				<h3 className="text-lg font-semibold pb-4 border-b border-gray-200">
					Shopify Subscription Discounts List
				</h3>
			</div>

			<Table<IShopifySubscriptionDiscountWithAction>
				collection={handleCollectionWithAction(
					collectionShopifySubscriptionDiscount,
				)}
				columns={columns}
				paginationSection={paginationOption}
				tableStyles={{
					tableBox: 'w-full overflow-y-auto h-48',
					table: 'w-full',
				}}
				dataTest="shopify-subscription-discounts-table"
			/>
		</div>
	);
};

export default ShopifySubscriptionDiscountTable;
